import { query } from '@/utils/device'
import { PRODUCT_ATTRIBUTE, PRODUCT_CATEGORY } from './const'

export default {
  RING: [
    {
      skuId: 'J10817',
      hidden: false,
      category: PRODUCT_CATEGORY.RING,
      attributes: [
        PRODUCT_ATTRIBUTE.COCOCRUSH,
        PRODUCT_ATTRIBUTE.BEIGE_GOLD,
        PRODUCT_ATTRIBUTE.TEST
      ],
      orderOfNew: 1,
      orderInAll: 1
    },
    {
      skuId: 'J11786',
      hidden: false,
      category: PRODUCT_CATEGORY.RING,
      attributes: [
        PRODUCT_ATTRIBUTE.COCOCRUSH,
        PRODUCT_ATTRIBUTE.BEIGE_GOLD,
        PRODUCT_ATTRIBUTE.DIAMOND,
        PRODUCT_ATTRIBUTE.TEST
      ],
      orderOfNew: 2,
      orderInAll: 8
    },
    {
      skuId: 'J13162',
      hidden: false,
      category: PRODUCT_CATEGORY.RING,
      attributes: [
        PRODUCT_ATTRIBUTE.COCOCRUSH,
        PRODUCT_ATTRIBUTE.BEIGE_GOLD,
        PRODUCT_ATTRIBUTE.DIAMOND
      ],
      orderOfNew: 3,
      orderInAll: 19
    },
    {
      skuId: 'J13186',
      hidden: false,
      category: PRODUCT_CATEGORY.RING,
      attributes: [
        PRODUCT_ATTRIBUTE.COCOCRUSH,
        PRODUCT_ATTRIBUTE.DIAMOND,
        PRODUCT_ATTRIBUTE.WHITE_GOLD
      ],
      orderOfNew: 4,
      orderInAll: 18
    },
    {
      skuId: 'J10818',
      hidden: false,
      category: PRODUCT_CATEGORY.RING,
      attributes: [PRODUCT_ATTRIBUTE.COCOCRUSH, PRODUCT_ATTRIBUTE.BEIGE_GOLD],
      orderOfNew: 5,
      orderInAll: 4
    },
    {
      skuId: 'J13163',
      hidden: false,
      category: PRODUCT_CATEGORY.RING,
      attributes: [
        PRODUCT_ATTRIBUTE.COCOCRUSH,
        PRODUCT_ATTRIBUTE.DIAMOND,
        PRODUCT_ATTRIBUTE.YELLOW_GOLD
      ],
      orderOfNew: 6,
      orderInAll: 21
    },
    {
      skuId: 'J12869',
      hidden: false,
      category: PRODUCT_CATEGORY.RING,
      attributes: [
        PRODUCT_ATTRIBUTE.COCOCRUSH,
        PRODUCT_ATTRIBUTE.DIAMOND,
        PRODUCT_ATTRIBUTE.WHITE_GOLD
      ],
      orderOfNew: 7,
      orderInAll: 15
    },
    {
      skuId: 'J12002',
      hidden: false,
      category: PRODUCT_CATEGORY.RING,
      attributes: [
        PRODUCT_ATTRIBUTE.PJN5,
        PRODUCT_ATTRIBUTE.DIAMOND,
        PRODUCT_ATTRIBUTE.WHITE_GOLD
      ],
      orderOfNew: 8,
      orderInAll: 12
    },
    {
      skuId: 'J11785',
      hidden: false,
      category: PRODUCT_CATEGORY.RING,
      attributes: [PRODUCT_ATTRIBUTE.COCOCRUSH, PRODUCT_ATTRIBUTE.BEIGE_GOLD],
      orderOfNew: 9,
      orderInAll: 5
    },
    {
      skuId: 'J13213',
      hidden: false,
      category: PRODUCT_CATEGORY.RING,
      attributes: [
        PRODUCT_ATTRIBUTE.COCOCRUSH,
        PRODUCT_ATTRIBUTE.DIAMOND,
        PRODUCT_ATTRIBUTE.WHITE_GOLD
      ],
      orderOfNew: 10,
      orderInAll: 20
    },
    {
      skuId: 'J13156',
      hidden: false,
      category: PRODUCT_CATEGORY.RING,
      attributes: [
        PRODUCT_ATTRIBUTE.COCOCRUSH,
        PRODUCT_ATTRIBUTE.BEIGE_GOLD,
        PRODUCT_ATTRIBUTE.DIAMOND
      ],
      orderOfNew: 11,
      orderInAll: 16
    },
    {
      skuId: 'J11871',
      hidden: false,
      category: PRODUCT_CATEGORY.RING,
      attributes: [
        PRODUCT_ATTRIBUTE.COCOCRUSH,
        PRODUCT_ATTRIBUTE.DIAMOND,
        PRODUCT_ATTRIBUTE.WHITE_GOLD
      ],
      orderOfNew: 12,
      orderInAll: 10
    },
    {
      skuId: 'J10571',
      hidden: false,
      category: PRODUCT_CATEGORY.RING,
      attributes: [PRODUCT_ATTRIBUTE.COCOCRUSH, PRODUCT_ATTRIBUTE.YELLOW_GOLD],
      orderOfNew: 13,
      orderInAll: 2
    },
    {
      skuId: 'J13209',
      hidden: false,
      category: PRODUCT_CATEGORY.RING,
      attributes: [
        PRODUCT_ATTRIBUTE.COCOCRUSH,
        PRODUCT_ATTRIBUTE.DIAMOND,
        PRODUCT_ATTRIBUTE.YELLOW_GOLD
      ],
      orderOfNew: 14,
      orderInAll: 17
    },
    {
      skuId: 'J12871',
      hidden: false,
      category: PRODUCT_CATEGORY.RING,
      attributes: [
        PRODUCT_ATTRIBUTE.COCOCRUSH,
        PRODUCT_ATTRIBUTE.BEIGE_GOLD,
        PRODUCT_ATTRIBUTE.DIAMOND
      ],
      orderOfNew: 15,
      orderInAll: 13
    },
    {
      skuId: 'J11794',
      hidden: false,
      category: PRODUCT_CATEGORY.RING,
      attributes: [PRODUCT_ATTRIBUTE.COCOCRUSH, PRODUCT_ATTRIBUTE.YELLOW_GOLD],
      orderOfNew: 16,
      orderInAll: 6
    },
    {
      skuId: 'J11971',
      hidden: false,
      category: PRODUCT_CATEGORY.RING,
      attributes: [
        PRODUCT_ATTRIBUTE.COCOCRUSH,
        PRODUCT_ATTRIBUTE.BEIGE_GOLD,
        PRODUCT_ATTRIBUTE.DIAMOND,
        PRODUCT_ATTRIBUTE.WHITE_GOLD
      ],
      orderOfNew: 17,
      orderInAll: 11
    },
    {
      skuId: 'J11872',
      hidden: false,
      category: PRODUCT_CATEGORY.RING,
      attributes: [
        PRODUCT_ATTRIBUTE.COCOCRUSH,
        PRODUCT_ATTRIBUTE.DIAMOND,
        PRODUCT_ATTRIBUTE.YELLOW_GOLD
      ],
      orderOfNew: 18,
      orderInAll: 9
    },
    {
      skuId: 'J11793',
      hidden: false,
      category: PRODUCT_CATEGORY.RING,
      attributes: [PRODUCT_ATTRIBUTE.COCOCRUSH, PRODUCT_ATTRIBUTE.WHITE_GOLD],
      orderOfNew: 19,
      orderInAll: 7
    },
    {
      skuId: 'J12870',
      hidden: false,
      category: PRODUCT_CATEGORY.RING,
      attributes: [
        PRODUCT_ATTRIBUTE.COCOCRUSH,
        PRODUCT_ATTRIBUTE.DIAMOND,
        PRODUCT_ATTRIBUTE.YELLOW_GOLD
      ],
      orderOfNew: 20,
      orderInAll: 14
    },
    {
      skuId: 'J10570',
      hidden: false,
      category: PRODUCT_CATEGORY.RING,
      attributes: [PRODUCT_ATTRIBUTE.COCOCRUSH, PRODUCT_ATTRIBUTE.WHITE_GOLD],
      orderOfNew: 21,
      orderInAll: 3
    },
    {
      skuId: 'S10570',
      hidden:
        process.env.VUE_APP_SDK_TYPE !== 'DEV' || query.version === 'release',
      category: PRODUCT_CATEGORY.RING,
      attributes: [PRODUCT_ATTRIBUTE.COCOCRUSH, PRODUCT_ATTRIBUTE.WHITE_GOLD],
      orderOfNew: 22,
      orderInAll: 22
    }
  ],
  BRACELETS: [
    {
      skuId: 'J13084',
      hidden: false,
      category: PRODUCT_CATEGORY.BRACELET,
      attributes: [
        PRODUCT_ATTRIBUTE.COCOCRUSH,
        PRODUCT_ATTRIBUTE.BEIGE_GOLD,
        PRODUCT_ATTRIBUTE.DIAMOND,
        PRODUCT_ATTRIBUTE.TEST
      ],
      orderOfNew: 1,
      orderInAll: 9
    },
    {
      skuId: 'J12324',
      hidden: false,
      category: PRODUCT_CATEGORY.BRACELET,
      attributes: [PRODUCT_ATTRIBUTE.COCOCRUSH, PRODUCT_ATTRIBUTE.BEIGE_GOLD],
      orderOfNew: 2,
      orderInAll: 3
    },
    {
      skuId: 'J13080',
      hidden: false,
      category: PRODUCT_CATEGORY.BRACELET,
      attributes: [
        PRODUCT_ATTRIBUTE.COCOCRUSH,
        PRODUCT_ATTRIBUTE.DIAMOND,
        PRODUCT_ATTRIBUTE.YELLOW_GOLD
      ],
      orderOfNew: 3,
      orderInAll: 10
    },
    {
      skuId: 'J11333',
      hidden: false,
      category: PRODUCT_CATEGORY.BRACELET,
      attributes: [PRODUCT_ATTRIBUTE.COCOCRUSH, PRODUCT_ATTRIBUTE.BEIGE_GOLD],
      orderOfNew: 4,
      orderInAll: 1
    },
    {
      skuId: 'J12809',
      hidden: false,
      category: PRODUCT_CATEGORY.BRACELET,
      attributes: [
        PRODUCT_ATTRIBUTE.COCOCRUSH,
        PRODUCT_ATTRIBUTE.DIAMOND,
        PRODUCT_ATTRIBUTE.WHITE_GOLD
      ],
      orderOfNew: 5,
      orderInAll: 11
    },
    {
      skuId: 'J12326',
      hidden: false,
      category: PRODUCT_CATEGORY.BRACELET,
      attributes: [
        PRODUCT_ATTRIBUTE.COCOCRUSH,
        PRODUCT_ATTRIBUTE.BEIGE_GOLD,
        PRODUCT_ATTRIBUTE.DIAMOND
      ],
      orderOfNew: 6,
      orderInAll: 6
    },
    {
      skuId: 'J11139',
      hidden: true,
      category: PRODUCT_CATEGORY.BRACELET,
      attributes: [PRODUCT_ATTRIBUTE.COCOCRUSH, PRODUCT_ATTRIBUTE.YELLOW_GOLD],
      orderOfNew: 7,
      orderInAll: 2
    },
    {
      skuId: 'J12325',
      hidden: false,
      category: PRODUCT_CATEGORY.BRACELET,
      attributes: [PRODUCT_ATTRIBUTE.COCOCRUSH, PRODUCT_ATTRIBUTE.YELLOW_GOLD],
      orderOfNew: 8,
      orderInAll: 5
    },
    {
      skuId: 'J12621',
      hidden: false,
      category: PRODUCT_CATEGORY.BRACELET,
      attributes: [PRODUCT_ATTRIBUTE.COCOCRUSH, PRODUCT_ATTRIBUTE.WHITE_GOLD],
      orderOfNew: 9,
      orderInAll: 4
    },
    {
      skuId: 'J12327',
      hidden: false,
      category: PRODUCT_CATEGORY.BRACELET,
      attributes: [
        PRODUCT_ATTRIBUTE.COCOCRUSH,
        PRODUCT_ATTRIBUTE.DIAMOND,
        PRODUCT_ATTRIBUTE.YELLOW_GOLD
      ],
      orderOfNew: 10,
      orderInAll: 7
    },
    {
      skuId: 'J12328',
      hidden: false,
      category: PRODUCT_CATEGORY.BRACELET,
      attributes: [
        PRODUCT_ATTRIBUTE.COCOCRUSH,
        PRODUCT_ATTRIBUTE.DIAMOND,
        PRODUCT_ATTRIBUTE.WHITE_GOLD
      ],
      orderOfNew: 11,
      orderInAll: 8
    }
  ],
  WATCH: [
    {
      skuId: 'H6951',
      hidden: false,
      category: PRODUCT_CATEGORY.WATCH,
      attributes: [PRODUCT_ATTRIBUTE.PREMIÈRE, PRODUCT_ATTRIBUTE.CALF],
      orderOfNew: 1,
      orderInAll: 9
    },
    {
      skuId: 'H5699',
      hidden: false,
      category: PRODUCT_CATEGORY.WATCH,
      attributes: [
        PRODUCT_ATTRIBUTE.J12,
        PRODUCT_ATTRIBUTE.WHITE_CERAMIC,
        PRODUCT_ATTRIBUTE.STAINLESS_STEEL,
        PRODUCT_ATTRIBUTE.TEST
      ],
      orderOfNew: 2,
      orderInAll: 1
    },
    {
      skuId: 'H5697',
      hidden: false,
      category: PRODUCT_CATEGORY.WATCH,
      attributes: [
        PRODUCT_ATTRIBUTE.J12,
        PRODUCT_ATTRIBUTE.STAINLESS_STEEL,
        PRODUCT_ATTRIBUTE.BLACK_CERAMIC
      ],
      orderOfNew: 3,
      orderInAll: 4
    },
    {
      skuId: 'H5703',
      hidden: false,
      category: PRODUCT_CATEGORY.WATCH,
      attributes: [
        PRODUCT_ATTRIBUTE.J12,
        PRODUCT_ATTRIBUTE.WHITE_CERAMIC,
        PRODUCT_ATTRIBUTE.STAINLESS_STEEL,
        PRODUCT_ATTRIBUTE.WATCH_DIAMOND
      ],
      orderOfNew: 4,
      orderInAll: 5
    },
    {
      skuId: 'H5696',
      hidden: false,
      category: PRODUCT_CATEGORY.WATCH,
      attributes: [
        PRODUCT_ATTRIBUTE.J12,
        PRODUCT_ATTRIBUTE.STAINLESS_STEEL,
        PRODUCT_ATTRIBUTE.BLACK_CERAMIC
      ],
      orderOfNew: 5,
      orderInAll: 2
    },
    {
      skuId: 'H5700',
      hidden: false,
      category: PRODUCT_CATEGORY.WATCH,
      attributes: [
        PRODUCT_ATTRIBUTE.J12,
        PRODUCT_ATTRIBUTE.WHITE_CERAMIC,
        PRODUCT_ATTRIBUTE.STAINLESS_STEEL
      ],
      orderOfNew: 6,
      orderInAll: 3
    },
    {
      skuId: 'H5701',
      hidden: false,
      category: PRODUCT_CATEGORY.WATCH,
      attributes: [
        PRODUCT_ATTRIBUTE.J12,
        PRODUCT_ATTRIBUTE.STAINLESS_STEEL,
        PRODUCT_ATTRIBUTE.BLACK_CERAMIC,
        PRODUCT_ATTRIBUTE.WATCH_DIAMOND
      ],
      orderOfNew: 7,
      orderInAll: 6
    },
    {
      skuId: 'H5705',
      hidden: false,
      category: PRODUCT_CATEGORY.WATCH,
      attributes: [
        PRODUCT_ATTRIBUTE.J12,
        PRODUCT_ATTRIBUTE.WHITE_CERAMIC,
        PRODUCT_ATTRIBUTE.STAINLESS_STEEL,
        PRODUCT_ATTRIBUTE.WATCH_DIAMOND
      ],
      orderOfNew: 8,
      orderInAll: 7
    },
    {
      skuId: 'H5702',
      hidden: false,
      category: PRODUCT_CATEGORY.WATCH,
      attributes: [
        PRODUCT_ATTRIBUTE.J12,
        PRODUCT_ATTRIBUTE.STAINLESS_STEEL,
        PRODUCT_ATTRIBUTE.BLACK_CERAMIC,
        PRODUCT_ATTRIBUTE.WATCH_DIAMOND
      ],
      orderOfNew: 9,
      orderInAll: 8
    }
  ],
  EARRINGS: [
    {
      skuId: 'J11754',
      hidden: false,
      category: PRODUCT_CATEGORY.EARRING,
      attributes: [PRODUCT_ATTRIBUTE.COCOCRUSH, PRODUCT_ATTRIBUTE.BEIGE_GOLD],
      orderOfNew: 1,
      orderInAll: 1
    },
    {
      skuId: 'J13307',
      hidden: false,
      category: PRODUCT_CATEGORY.EARRING,
      attributes: [
        PRODUCT_ATTRIBUTE.COCOCRUSH,
        PRODUCT_ATTRIBUTE.YELLOW_GOLD,
        PRODUCT_ATTRIBUTE.DIAMOND
      ],
      orderOfNew: 2,
      orderInAll: 11
    },
    {
      skuId: 'J13311',
      hidden: false,
      category: PRODUCT_CATEGORY.EARRING,
      attributes: [
        PRODUCT_ATTRIBUTE.COCOCRUSH,
        PRODUCT_ATTRIBUTE.BEIGE_GOLD,
        PRODUCT_ATTRIBUTE.DIAMOND
      ],
      orderOfNew: 3,
      orderInAll: 13
    },
    {
      skuId: 'J12157',
      hidden: true,
      category: PRODUCT_CATEGORY.EARRING,
      attributes: [PRODUCT_ATTRIBUTE.COCOCRUSH, PRODUCT_ATTRIBUTE.YELLOW_GOLD],
      orderOfNew: 4,
      orderInAll: 6
    },
    {
      skuId: 'J12092',
      hidden: true,
      category: PRODUCT_CATEGORY.EARRING,
      attributes: [PRODUCT_ATTRIBUTE.COCOCRUSH, PRODUCT_ATTRIBUTE.BEIGE_GOLD],
      orderOfNew: 5,
      orderInAll: 3
    },
    {
      skuId: 'J13312',
      hidden: false,
      category: PRODUCT_CATEGORY.EARRING,
      attributes: [
        PRODUCT_ATTRIBUTE.COCOCRUSH,
        PRODUCT_ATTRIBUTE.DIAMOND,
        PRODUCT_ATTRIBUTE.WHITE_GOLD
      ],
      orderOfNew: 6,
      orderInAll: 15
    },
    {
      skuId: 'J12119',
      hidden: true,
      category: PRODUCT_CATEGORY.EARRING,
      attributes: [
        PRODUCT_ATTRIBUTE.CAMÉLIA,
        PRODUCT_ATTRIBUTE.ROSE_GOLD,
        PRODUCT_ATTRIBUTE.DIAMOND
      ],
      orderOfNew: 7,
      orderInAll: 4
    },
    {
      skuId: 'J12686',
      hidden: false,
      category: PRODUCT_CATEGORY.EARRING,
      attributes: [PRODUCT_ATTRIBUTE.COCOCRUSH, PRODUCT_ATTRIBUTE.BEIGE_GOLD],
      orderOfNew: 8,
      orderInAll: 7
    },
    {
      skuId: 'J13310',
      hidden: false,
      category: PRODUCT_CATEGORY.EARRING,
      attributes: [
        PRODUCT_ATTRIBUTE.COCOCRUSH,
        PRODUCT_ATTRIBUTE.YELLOW_GOLD,
        PRODUCT_ATTRIBUTE.DIAMOND
      ],
      orderOfNew: 9,
      orderInAll: 14
    },
    {
      skuId: 'J13309',
      hidden: false,
      category: PRODUCT_CATEGORY.EARRING,
      attributes: [
        PRODUCT_ATTRIBUTE.COCOCRUSH,
        PRODUCT_ATTRIBUTE.DIAMOND,
        PRODUCT_ATTRIBUTE.WHITE_GOLD
      ],
      orderOfNew: 10,
      orderInAll: 12
    },
    {
      skuId: 'J11134',
      hidden: true,
      category: PRODUCT_CATEGORY.EARRING,
      attributes: [PRODUCT_ATTRIBUTE.COCOCRUSH, PRODUCT_ATTRIBUTE.YELLOW_GOLD],
      orderOfNew: 11,
      orderInAll: 2
    },
    {
      skuId: 'J12687',
      hidden: false,
      category: PRODUCT_CATEGORY.EARRING,
      attributes: [PRODUCT_ATTRIBUTE.COCOCRUSH, PRODUCT_ATTRIBUTE.WHITE_GOLD],
      orderOfNew: 12,
      orderInAll: 9
    },
    {
      skuId: 'J13308',
      hidden: false,
      category: PRODUCT_CATEGORY.EARRING,
      attributes: [
        PRODUCT_ATTRIBUTE.COCOCRUSH,
        PRODUCT_ATTRIBUTE.BEIGE_GOLD,
        PRODUCT_ATTRIBUTE.DIAMOND
      ],
      orderOfNew: 13,
      orderInAll: 10
    },
    {
      skuId: 'J12149',
      hidden: false,
      category: PRODUCT_CATEGORY.EARRING,
      attributes: [PRODUCT_ATTRIBUTE.COCOCRUSH, PRODUCT_ATTRIBUTE.BEIGE_GOLD],
      orderOfNew: 14,
      orderInAll: 5
    },
    {
      skuId: 'J12685',
      hidden: false,
      category: PRODUCT_CATEGORY.EARRING,
      attributes: [PRODUCT_ATTRIBUTE.COCOCRUSH, PRODUCT_ATTRIBUTE.YELLOW_GOLD],
      orderOfNew: 15,
      orderInAll: 8
    }
  ]
}
